<template>
  <div>
    <!-- 收货地址弹出框 -->
    <van-popup
      class="assignPersonnelPicker-box"
      @close="addressPickerClose"
      v-model="addressPickerShow"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="header">
        <span class="title">{{ header }}</span>
        <van-icon @click="closePicker()" size="12px" name="cross" color="#A2A3A4" />
      </div>
      <div class="tab-box">
        <div
          v-for="(item, index) in cityTabList"
          @click="addressTabClick(item, index)"
          :key="index"
          class="tab"
          :class="tabActive === item.code ? 'tab-active' : ''"
        >{{ item.shortName }}</div>
        <!-- <div class="tab-active">{{ 'yeyg' }}</div> -->
        <div v-if="cityTabList.length < 2" class="tab-active">请选择</div>
      </div>
      <div class="person-list" style="max-height: 310px;">
        <div
          v-for="(item, index) of tabPaneList"
          :key="index"
          class="person-item"
          @click="selectArea(item)"
        >
          <span class="name">{{ item.shortName }}</span>
          <van-icon
            v-if="item.id === areaItem.id"
            class="select-icon"
            color="#36B374"
            name="success"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import api from '../../../../service/modules/refund'

export default {
  props: {
    header: {
      type: String,
      required: false,
      default: "收货地址"
    }
  },
  data() {
    return {
      addressPickerShow: false, // 收货地址弹框显示
      cityTabList: [], // 已选择的的地址,tab选项
      tabActive: "",
      tabPaneList: [], // 对应tab的地区列表
      areaItem: {}, // 点击选中的area
      ShippingAddress: "请选择", // 收货地址
      allAreaList: [] // 所有地区列表
    };
  },
  created() {
    this.getCity();
  },
  methods: {
    init() {
      this.addressPickerShow = true
      this.getCity()
    },
    // 关闭弹窗
    closePicker() {
      this.addressPickerShow = false
      this.$emit('addressPickerClose', this.cityTabList)
    },
    // 获取云南省的下级地址
    getCity() {
      api.getCity().then(res => {
        if (res.ret === 0 && res.data[0].children.length > 0) {
          if (res.data[0].children.length > 0) {
            this.allAreaList = res.data[0].children;
            this.areaInit();
          }
        }
      });
    },
    // 初始化地区的显示
    areaInit() {
      if (this.cityTabList.length === 0) {
        this.tabPaneList = this.allAreaList;
      } else if (this.cityTabList.length === 1) {
      }
    },
    // 点击地区选择
    selectArea(item) {
      // 如果还没有选择地区，添加tab选项
      if (this.cityTabList.length === 0) {
        this.cityTabList.push(item);
        this.allAreaList.map(i => {
          if (i.code === item.code) {
            this.tabPaneList = i.children;
          }
        });
      } else if (this.cityTabList.length === 1) {
        this.cityTabList.push(item);
        // this.cityTabList[0] = item;
        this.addressPickerShow = false
      } else if (this.cityTabList.length === 2) {
        this.cityTabList[1] = item;
      }
      this.areaItem = item;
      this.tabActive = item.code;
      this.$emit('selectArea', this.cityTabList)
    },
    // 地址tab选项点击事件
    addressTabClick(item, index) {
      this.tabActive = item.code;
      // 如果点击第一项
      if (index === 0) {
        this.tabPaneList = this.allAreaList;
        this.cityTabList = [];
      }
    },
    // 收货地址弹框关闭事件
    addressPickerClose() {
      let addressName = [];
      if (this.cityTabList.length > 0) {
        this.cityTabList.map(item => {
          addressName.push(item.shortName);
        });
        this.ShippingAddress = addressName.join(" - ");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.assignPersonnelPicker-box {
  padding: 0 16px;
  .header {
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    .title {
      font-size: 16px;
      color: #171a1d;
    }
  }
  .tab-box {
    display: flex;
    border-bottom: 1px solid #f5f6f9;
    padding-top: 11px;
    .tab {
      margin-right: 21px;
      font-size: 14px;
      color: #666666;
      padding-bottom: 14.5px;
    }
    .tab-active {
      margin-right: 21px;
      font-size: 14px;
      color: #171a1d;
      padding-bottom: 14.5px;
      border-bottom: 1px solid #36b374;
    }
  }
  .person-list {
    max-height: 350px;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    .person-item {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #f5f6f9;
    }
  }
  .box1 {
    text-align: center;
    margin-top: 64px;
    padding-bottom: 87px;
    img {
      display: inline-block;
      width: 74px;
      height: 62px;
    }
    .tip1 {
      font-size: 14px;
      color: #9b9b9b;
      margin-top: 24px;
    }
    .tip2 {
      font-size: 14px;
      color: #9b9b9b;
      margin-top: 8px;
    }
  }
}
</style>